import { useCallback } from "react";
import { useAuthQuery } from "./useAuthQuery";

export const useGetRequestsList = () => {
  const select = useCallback((data) => {
    return data?.data?.data;
  }, []);

  const response = useAuthQuery(
    {
      method: "POST",
      url: "/agent/listfr",
    },

    {
      queryKey: ["fuel-request-list"],
      select,
      staleTime: Infinity,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  );

  return response;
};
